import {Expose} from "class-transformer";

export default class ModelRates {
    @Expose({name: "buy"})
    private readonly _buy: number;
    @Expose({name: "sell"})
    private readonly _sell: number;
    @Expose({name: "wallet"})
    private readonly _wallet: number;

    constructor(buy: number, sell: number, wallet: number) {
        this._buy = buy;
        this._sell = sell;
        this._wallet = wallet;
    }

    public get buy() {
        return this._buy;
    }

    public get sell() {
        return this._sell;
    }

    public get wallet() {
        return this._wallet;
    }
}
